import React, { useEffect } from 'react';
import { deleteAuthCookies } from '../../utils/auth';

function ClearLocalCache() {
  useEffect(() => {
    window.localStorage.clear();
    window.sessionStorage.clear();
    deleteAuthCookies();
    window.location.replace('/sign-in');
  }, []);

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
      Clearing cache...
    </div>
  );
}

export default ClearLocalCache;
